import React, { Component } from 'react';
import TwitterService from '../../../services/twitter';

import './twitter-instagram-candidates.css';

class TwitterInstagramCandidates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      isLoading: true,
    };

    this.getCandidates(props);
  }

  getCandidates(props) {
    TwitterService.getCandidates(props.location.search)    
      .then((candidates) => {
        this.setState({ 
          candidates: candidates.map(c => ({
            ...c,
            approved: true
          })),
          isLoading: false
        });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  getOnChange = (idStr) => {
    return (event) => {
      this.setState((prevState) => {
        return {
          candidates: prevState.candidates.map(candidate => {
            const additionals = {};

            if (candidate.idStr === idStr) {
              additionals.approved = !candidate.approved;
            }

            return {
              ...candidate,
              ...additionals
            };
          })
        }
      })
    }
  }

  getImg = (imgUrl) => {
    if (!imgUrl) return '';
    return <img src={imgUrl} height='70px'/>;
  }

  onSave = () => {
    this.setState({
      isLoading: true,
    });
    
    TwitterService.saveCandidates(this.state.candidates)    
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  render() {
    const generalFields = ['name', 'location', 'screenName', 'description', ];
    
    let body = 'Processing...';
    if (this.state && this.state.candidates && !this.state.isLoading) {
      body = (
        <div>  
          <input type='button' value='Save' onClick={this.onSave}/>

          <section>
            {
              this.state.candidates.map((candidate, i) => 
                <div key={candidate.idStr} 
                  className={(!candidate.approved && 'hide') || ''}
                  onClick={this.getOnChange(candidate.idStr)}
                  >
                  <div><label>{i + 1} out of {this.state.candidates.length}</label></div>
                                
                  { this.getImg(candidate.img) }

                  {
                    generalFields.map(field => candidate[field]).filter(x=>x).join(' | ')
                  }
                <hr/>
              </div>
              )
            }
          </section>

          <input type='button' value='Save' onClick={this.onSave}/>
        </div>
      );
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page twitter-instagram-candidates'>
        {body}
      </section>
    );
  }
}

export default TwitterInstagramCandidates;
